import ButtonIcon from "components/ButtonIcon";
import Table from "components/Template/Table";
import dateformat from "dateformat";
import React, { useState } from "react";
import Close from "icons/close-circle.svg";
import CloseDisabled from "icons/confirm-circle-green.svg";
import Loading from "components/Loading";
import { ToastContainer } from "react-toastify";
import ChangeStatusModal from "./ChangeStatusModal";

type Props = {
  memberList: any;
  groupId: string;
  rechargeMembers: () => void;
};

const TableMembers: React.FC<Props> = ({
  memberList,
  groupId,
  rechargeMembers,
}): JSX.Element => {
  const [loading, setLoading] = useState(false);
  const [active, setActive] = useState(false);
  const [show, setShow] = useState(false);
  const [memberId, setMemberId] = useState("");

  return (
    <>
      <Loading loading={loading} />
      <ChangeStatusModal
        setMemberId={setMemberId}
        show={show}
        setShow={setShow}
        memberId={memberId}
        groupId={groupId}
        setLoading={setLoading}
        active={active}
        rechargeMembers={rechargeMembers}
      />
      {memberList.length > 0 ? (
        <Table
          childrenThead={
            <tr className="font-sora">
              <td className="px-7">Name</td>
              <td>Email</td>
              <td>Role</td>
              <td>Created</td>
              <td className="px-7">Status</td>
            </tr>
          }
          childrenTbody={
            <>
              {memberList.map((member: any, i: number) => (
                <tr
                  className={`font-sora`}
                  style={{
                    background: member.active === true ? "#FFFFFF" : "#E7E9EF",
                    color: member.active === true ? "#2A2B31" : "#707070",
                  }}
                  key={i}
                >
                  <td className="px-7 py-7">{member.userData[0].name}</td>
                  <td>{member.userData[0].email}</td>
                  <td>{member.role}</td>
                  <td>{dateformat(member.createdAt, "mm.dd.yyyy")}</td>
                  <td className="px-7" style={{ width: "70px" }}>
                    {member.active === true ? (
                      <ButtonIcon
                        icon={CloseDisabled}
                        status={true}
                        onClick={() => {
                          setActive(false);
                          setMemberId(member.userData[0]._id);
                          setShow(true);
                        }}
                      />
                    ) : (
                      <ButtonIcon
                        icon={Close}
                        status={true}
                        onClick={() => {
                          setActive(true);
                          setMemberId(member.userData[0]._id);
                          setShow(true);
                        }}
                      />
                    )}
                  </td>
                </tr>
              ))}
            </>
          }
        />
      ) : (
        <div className="flex flex-row justify-center items-center">
          <span
            className="font-nunito text-lg"
            style={{
              fontStyle: "normal",
              fontWeight: 400,
              color: "#4A4A4A",
            }}
          >
            No member data
          </span>
        </div>
      )}
      <ToastContainer />
    </>
  );
};

export default TableMembers;
